// =============================================================================
// offlineQueue.js — cola de reintentos para mutaciones en modo offline (RX-5)
// -----------------------------------------------------------------------------
// Cuando una petición NO-GET falla por falta de conexión, se encola en
// localStorage (sobrevive recargas) y se notifica a la UI vía CustomEvent
// 'nexus:queue-changed'. El usuario (o el evento 'online') dispara el reintento
// desde `useConnectivity.flush()`; las operaciones exitosas se retiran de la
// cola y las fallidas por validación se conservan para no perder datos.
// =============================================================================
const QUEUE_KEY = 'nexus_offline_queue_v1';

export const loadQueue = () => {
  try {
    const raw = localStorage.getItem(QUEUE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch (error) {
    console.warn('No se pudo leer la cola offline:', error);
    return [];
  }
};

const persistQueue = (list) => {
  try {
    localStorage.setItem(QUEUE_KEY, JSON.stringify(list));
    window.dispatchEvent(new CustomEvent('nexus:queue-changed'));
  } catch (error) {
    console.warn('No se pudo guardar la cola offline:', error);
  }
};

/**
 * Encola una mutación fallida por falta de conexión.
 * @param {{ method: string, url: string, data?: any, config?: any }} request
 * @returns {number} cantidad de operaciones encoladas
 */
export const enqueueMutation = (request) => {
  const list = loadQueue();
  const entry = {
    id: `${Date.now()}-${Math.random().toString(36).slice(2)}`,
    method: request.method,
    url: request.url,
    data: request.data ?? null,
    config: request.config ?? null,
    queuedAt: new Date().toISOString(),
  };
  list.push(entry);
  persistQueue(list);
  return list.length;
};

export const clearQueueItem = (id) => {
  persistQueue(loadQueue().filter((item) => item.id !== id));
};

export const clearQueue = () => {
  persistQueue([]);
};